import useIsMobile from 'utils/hooks/useIsMobile'
import {FC} from 'react'
import {useSelector} from 'react-redux'
import {useLayout} from '../../../core/LayoutProvider'
import {usePageData} from '../../../core/PageData'

const DefaultTitle: FC = () => {
  const {pageTitle, pageDescription, pageBreadcrumbs} = usePageData()
  const {config} = useLayout()
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const isMobile = useIsMobile()
  return (
    <>
      {!isMobile && (
        <div className='h-full py-2'>
          {/* begin::Title */}
          <img
            srcSet={userInfo?.imageUrl}
            alt='logo'
            // width={'70%'}
            // height={'80%'}
            className={'h-full'}
          />
        </div>
      )}
      {isMobile && (
        <div className='flex items-center'>
          <img srcSet={userInfo?.imageUrl} alt='logo' style={{height: 28, width: 'auto'}} />
        </div>
      )}
      {/*<img srcSet={userInfo?.imageUrl} alt='logo' sizes={''} />*/}
      {/*{pageTitle && (*/}
      {/*  <>*/}
      {/*    <h1*/}
      {/*      className='d-flex flex-column text-dark fw-bolder w-100  mb-0 ms-0 '*/}
      {/*      style={{fontSize: '20px', textAlign: 'left'}}*/}
      {/*    >*/}
      {/*      {pageTitle}*/}
      {/*      {pageDescription && config.pageTitle && config.pageTitle.description && (*/}
      {/*        <>*/}
      {/*          <span className='h-20px border-gray-200 border-start ms-3 mx-2'></span>*/}
      {/*          <small className='text-muted fs-7 fw-bold my-1 ms-1'>{pageDescription}</small>*/}
      {/*        </>*/}
      {/*      )}*/}
      {/*    </h1>*/}
      {/*  </>*/}
      {/*)}*/}

      {/* end::Title */}

      {/*{pageBreadcrumbs && pageBreadcrumbs.length > 0 && (*/}
      {/*  <ul className='breadcrumb breadcrumb-separatorless fw-bold fs-5 pt-1'>*/}
      {/*    {Array.from(pageBreadcrumbs).map((item, index) => (*/}
      {/*      <li*/}
      {/*        className={clsx('breadcrumb-item', {*/}
      {/*          'text-dark': !item.isSeparator && item.isActive,*/}
      {/*          'text-muted': !item.isSeparator && !item.isActive,*/}
      {/*        })}*/}
      {/*        key={`${item.path}${index}`}*/}
      {/*      >*/}
      {/*        {!item.isSeparator ? (*/}
      {/*          <Link className='text-muted text-hover-primary' to={item.path}>*/}
      {/*            {item.title}*/}
      {/*          </Link>*/}
      {/*        ) : (*/}
      {/*          <span className='bullet bg-gray-200 w-5px h-2px'></span>*/}
      {/*        )}*/}
      {/*      </li>*/}
      {/*    ))}*/}
      {/*    <li className='breadcrumb-item text-dark'>{pageTitle}</li>*/}
      {/*  </ul>*/}
      {/*)}*/}
    </>
  )
}

export {DefaultTitle}
